import React from "react";
import { Box, Button, Container, Link, Paper, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { login } from "../api/auth";
import { useSnack } from "../services/SnakbarProvider";
import { handleError } from "../services/errorHandler";
import { isTokenExpired } from "../services/auth";

const validationSchema = Yup.object({
  email: Yup.string().email("Ingresa un email válido").required("El email es requerido"),
  password: Yup.string().required("La contraseña es requerida"),
});

export default function LoginPage() {
  const { openSnack } = useSnack();
  const navigate = useNavigate();

  if (!isTokenExpired()) {
    navigate("/orders", { replace: true });
  }

  const formik = useFormik({
    initialValues: { email: "", password: "" },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const res = await login(values.email, values.password);
        localStorage.setItem("accessToken", res.data.token);
        navigate("/orders", { replace: true });
      } catch (e) {
        openSnack(handleError(e), "error");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Paper sx={{ p: 4 }}>
        <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
          Portal de Clientes
        </Typography>
        <Box component="form" onSubmit={formik.handleSubmit}>
          <TextField
            required
            fullWidth
            margin="normal"
            id="email"
            name="email"
            label="Email"
            autoComplete="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            autoFocus
          />
          <TextField
            required
            fullWidth
            margin="normal"
            id="password"
            name="password"
            label="Contraseña"
            type="password"
            autoComplete="current-password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={formik.isSubmitting}
            sx={{ mt: 3, mb: 2 }}
          >
            Iniciar Sesión
          </Button>
          <Box sx={{ textAlign: "center" }}>
            <Link
              component="button"
              type="button"
              variant="body2"
              onClick={() => navigate("/forgot-password")}
              sx={{ textDecoration: "none" }}
            >
              Reestablecer contraseña
            </Link>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}
